export enum FeatureKey {
  GLOBAL_MARKET_ACCESS = "global_market_access",
  UNLIMITED_ARBITRAGE = "unlimited_arbitrage",
  CUSTOM_LIBRARY = "custom_library",
  CUSTOMIZABLE_INDEXES = "customizable_indexes",
  SAVE_FILTER = "save_filter",
  TWENTY_FOUR_HOUR_ACTIVITY_FILTER = "24h_activity_filter",
  SPREAD_FILTER = "spread_filter",
  APY_FILTER = "apy_filter",
  ROI_FILTER = "roi_filter",
  PROBABILITY_SLIDER = "probability_slider",
  WATCHLIST_LIMIT_THREE = "watchlist_limited_to_3_events",
  WATCHLIST_NO_LIMITS = "watchlist_no_limits",
}
